import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { SuccessComponent } from './pages/msg/success/success.component';
import { ErrorComponent } from './pages/msg/error/error.component';
import { QrComponent } from './pages/scan/qr/qr.component';
import { CodeComponent } from './pages/scan/code/code.component';
import { QrEventComponent } from './pages/event/qr-event/qr-event.component';
import { SlotSelectionComponent } from './pages/event/slot-selection/slot-selection.component';
import { MainComponent } from './pages/main/main.component';
import { canMatchGuard } from './guard/can-match.guard';
import { UserRoles } from './services/user.config';

export const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    children: [
      { path: '', component: HomeComponent },
      {
        path: 'qrScan',
        component: QrComponent,
        canMatch: [canMatchGuard],
        data: {
          role: [UserRoles.storeAdmin.id],
        },
      },
      {
        path: 'event',
        canMatch: [canMatchGuard],
        data: {
          role: [UserRoles.promoter.id],
        },
        children: [
          { path: '', component: SlotSelectionComponent },
          { path: 'qrScan/:event_id', component: QrEventComponent },
        ],
      },
      {
        path: 'manualScan',
        component: CodeComponent,
        canMatch: [canMatchGuard],
        data: {
          role: [UserRoles.storeAdmin.id],
        },
      },
      {
        path: 'msgSuccess',
        component: SuccessComponent,
        canMatch: [canMatchGuard],
        data: {
          role: [UserRoles.storeAdmin.id],
        },
      },
      {
        path: 'msgError',
        component: ErrorComponent,
        canMatch: [canMatchGuard],
      },
    ],
  },
];
